module.exports = __webpack_public_path__ + "static/media/rf2.de08ddaa.jpeg";